export default __webpack_public_path__ + "static/media/q28_v2.20f3896b.png";